import keyMirror from 'keymirror';
import { processRequest } from '../../services/Api';
import { TUTORING_BASE_PATH } from '../../services/Constants';

export const tutoringSharedTypes = keyMirror({
	SIGN_UP_LIVE_LESSON_REQUEST: null,
	SIGN_UP_LIVE_LESSON_SUCCESS: null,
	SIGN_UP_LIVE_LESSON_ERROR: null,

	SEND_LOGS_REQUEST: null,
	SEND_LOGS_SUCCESS: null,
	SEND_LOGS_ERROR: null,
});

export const processTutoringRequest = (
	path = '',
	method = 'GET',
	data = {},
	file = false,
	typoChecker = false,
	additionalHeaders = {},
	externalAPI = false,
) => {
	return processRequest(
		`${TUTORING_BASE_PATH}${path}`,
		method,
		data,
		file,
		typoChecker,
		additionalHeaders,
		externalAPI,
	);
};

export const PRO_SHOP_PAGE_URL = '/public-shops/18';
